

export enum FilterType {
Checkbox = 0,
PriceRange = 1,
}